<ng-container *ngFor="let fab of fabs$ | async">
    <ng-container *ngTemplateOutlet="fabTemplate; context: {$implicit: fab}"></ng-container>
</ng-container>
<ng-template #fabTemplate
             let-fab>
    <button class="fab"
            [attr.title]="fab?.title"
            [ngStyle]="fab?.style"
            (click)="fab?.action()">
        <layout-fab-badge [badge]="fab.badge"
                          *ngIf="fab?.badge"></layout-fab-badge>
        <app-svg [use]="fab?.svg" aria-hidden="true"></app-svg>
        <ng-container *ngTemplateOutlet="fab?.template"></ng-container>
    </button>
</ng-template>
